<template>
  <el-dialog
    :close-on-click-modal="false"
    title="打包申请开票"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
        :colNum="1"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="sub">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  invoiceBillInfo,
  invoiceOpenBill,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: [],
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'busiAmount',
                label: '业务总金额',
                span: 2,
              },
              {
                prop: 'billServiceAmount',
                label: '票据服务费',
                span: 2,
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        bill: {
          label: '收票信息',
          tableData: {
            title: [
              {
                prop: 'invoiceTitle',
                label: '发票(企业名称)',
              },
              {
                prop: 'dutyParagraph',
                label: '税号(社会信用代码)',
              },
              {
                prop: 'registeredAddress',
                label: '注册住所',
              },
              {
                prop: 'consigneePhone',
                label: '注册电话',
              },
              {
                prop: 'bankName',
                label: '开户银行',
              },
              {
                prop: 'acctNo',
                label: '银行账户',
              },
              {
                prop: 'consignee',
                label: '收件人',
              },
              {
                prop: 'telPhone',
                label: '收件人电话',
              },
              {
                prop: 'mailAddress',
                label: '邮寄地址',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  methods: {

    /**
     * @param {Array} arr 数组
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (arr) {
      this.originData = arr;
      const flowId = arr.map((item) => item.flowId);
      const res = await invoiceBillInfo({
        flowId: flowId.join(','),
      });
      if (!res.failed) {
        this.dialogFormVisible = true; // 打开弹窗
        this.detailData.base.tableData.data = res;
        this.detailData.bill.tableData.data = res;
      }
    },
    async sub () {
      const flowId = this.originData.map((item) => item.flowId);
      const res = await invoiceOpenBill({
        flowId: flowId.join(','),
      });
      if (!res.failed) {
        this.$alert(`提交成功，申请号:${res.applyNum}`, '申请成功', {
          confirmButtonText: '确定',
        });
        this.dialogFormVisible = false;
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
